"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DrawerContent", {
  enumerable: true,
  get: function get() {
    return _DrawerContent["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mui = require("tss-react/mui");
var _styles = require("@mui/material/styles");
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DrawerContent = _interopRequireDefault(require("./DrawerContent"));
var _excluded = ["open", "handleClose", "children", "anchor", "extraWidth"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    root: _defineProperty({
      backgroundColor: theme.palette.common.white,
      width: '50%',
      minWidth: theme.breakpoints.md
    }, theme.breakpoints.down('md'), {
      width: '100%',
      minWidth: 0
    }),
    extraWidth: {
      width: '80%'
    },
    backdrop: {
      backgroundColor: (0, _styles.alpha)(theme.palette.background.backdrop, 0.6)
    }
  };
});
var Drawer = function Drawer(_ref) {
  var open = _ref.open,
    handleClose = _ref.handleClose,
    children = _ref.children,
    anchor = _ref.anchor,
    extraWidth = _ref.extraWidth,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/_react["default"].createElement(_Drawer["default"], _extends({
    anchor: anchor,
    open: open,
    onClose: handleClose,
    BackdropProps: {
      className: classes.backdrop
    },
    PaperProps: {
      className: cx(classes.root, extraWidth && classes.extraWidth)
    }
  }, other), children({
    DrawerContentProps: {
      handleClose: handleClose
    }
  }));
};
Drawer.propTypes = {
  open: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].func.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  anchor: _propTypes["default"].oneOf(['right', 'left']),
  extraWidth: _propTypes["default"].bool
};
Drawer.defaultProps = {
  anchor: 'right',
  extraWidth: false
};
var _default = Drawer;
exports["default"] = _default;